import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ICurrentWorkingProjectData } from '../../../../models/project/project-dashboard.model';
@Component({
  selector: 'app-current-working-project',
  templateUrl: './current-working-project.component.html',
  styleUrls: ['./current-working-project.component.scss'],
  standalone: false,
})
export class CurrentWorkingProjectComponent {
  @Input() currentWorkingProjectData!: ICurrentWorkingProjectData;
  colorScheme = {
    domain: ['#6c7481', '#c1cfe9', '#c1cfe9', '#c1cfe9', '#c1cfe9'],
  };
  xAxisTickFormatting = (val: string) => {
    return val.length > 16 ? val.substring(0, 13) + '...' : val;
  };
}
